import React from "react";

function ShipToCell({ data }) {
  const raw = data?.shipTo;

  if (raw && (raw === "—" || String(raw).startsWith("Mixed"))) {
    if (raw === "—") {
      return (
        <span className="pg-cell-ship-to-block">
          <span className="pg-cell-dim">—</span>
        </span>
      );
    }
    return (
      <span className="pg-cell-ship-to-block">
        <em className="pg-cell-muted">{raw}</em>
      </span>
    );
  }

  const code =
    (data?.shipToCode && String(data.shipToCode).trim()) ||
    (raw ? String(raw).split("\n")[0].trim() : "") ||
    "—";

  if (code === "—") {
    return (
      <span className="pg-cell-ship-to-block">
        <span className="pg-cell-dim">—</span>
      </span>
    );
  }

  return (
    <span className="pg-cell-ship-to-block">
      <span className="pg-cell-ship-to-code">{code}</span>
    </span>
  );
}

export default ShipToCell;
